module.exports = __webpack_public_path__ + "static/media/caseysstorelogo.660d3f10.png";